import {
    Component,
    ViewEncapsulation,
    Inject,
    Input,
    OnInit,
    OnDestroy,
    AfterViewInit
} from '@angular/core';

import {
    Http,
    HTTP_PROVIDERS,
    Headers
} from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { DashboardMainComponent } from './dashboard.main.component';
import { DashboardCardComponent } from './dashboard.card.component';

import { Global } from '../../../system/services/global';

@Component({
    selector: 'dashboard',
    template: require('./dashboard.component.html'),
    // encapsulation: ViewEncapsulation.Native,
    styles: [],
    directives: [
        DashboardCardComponent,
        DashboardMainComponent
    ],
    providers: [
        HTTP_PROVIDERS,
        { provide: 'Window',  useValue: window },
        { provide: 'Document',  useValue: document },
        { provide: 'Io',  useValue: io }
    ]
})
export class Dashboard implements OnInit, OnDestroy {
    public currentSite = false;
    private socket;
    private sites;
    // observable data streams
    private inboundStream;
    private outboundStream;
    private lateralStream;
    private mode;
    // for now we'll pass the children an event emitter for when the client changes
    // so they can cresubscribe to the streams
    private newStream = new Subject();
    constructor(
        private http: Http,
        @Inject('Window') public window,
        @Inject('Document') public document,
        @Inject('Global') private global
        @Inject('Io') private io
    ) {}
    /////////////////////
    // LIFESTYLE HOOKS //
    /////////////////////
    ngOnInit()
    {
        this.connectSocket();
        // get sockets
        this.socket.on('sites', (sites) => {
            this.sites = sites;
        })
    }

    ngOnDestroy()
    {
        if (this.socket)
        {
            this.socket.off("disconnect");

            this.socket.disconnect();
        }

        this.newStream.complete();
    }
    /////////////
    // METHODS //
    /////////////
    // set current site for card to access
    setCurrentSite(event) {
        this.currentSite = event.site;
        // this.newStream.complete();
    }
    public fullscreenEnabled()
    {
        try {
            // FF provides nice flag, maybe others will add support for this later on?
            if (this.window['fullScreen'] !== undefined) {
                return this.window.fullScreen;
            } else if(this.document.fullscreenElement) {
                return true;
            } else if(this.document.webkitFullscreenElement ){
                return true;
            } else if (this.document.mozFullScreenElement){
                return true;
            // NOTE: leaving this else-if to come back to if there are issues with specific
            // browsers not being able to detect fullscreen mode
            // } else if (screen.width == this.window.innerWidth &&
            //     Math.abs(screen.height - this.window.innerHeight) < heightMargin) {
            //     return true;
            } else {
                return false;
            }
        } catch(error) {
            console.log(error)
            console.log(error.stack)
            console.log('Unable to check full screen mode.');
            return false;
        }
    }

    private connectSocket()
    {
        let self = this;

        let WebSockets =
        {
            isConnected: false,
            interval: null,
            connect()
            {
                self.socket = self.io.connect(self.global.api+'/api/landing/live',
                {
                    secure: true,
                    query: 'token=' + self.window.sessionStorage.token,
                    forceNew: true,
                    reconnection: false
                });

                self.socket.on('connect', () =>
                {
                    this.isConnected = true;
                });

                self.socket.on('disconnect', () =>
                {
                    this.isConnected = false;
                    this.interval = setInterval(() =>
                    {
                        if (this.isConnected)
                        {
                            clearInterval(this.interval);
                            this.interval = null;

                            return;
                        }

                        location.reload();
                    }, 10000);
                });
            }
        }

        // Setup streams, skip when the window is not in view
        this.inboundStream = self.incoming("inbound");
        this.outboundStream = self.incoming("outbound");
        this.lateralStream = self.incoming("lateral");

        WebSockets.connect();
    }

    private incoming(id)
    {
        let observable = new Observable((observer) =>
        {
            this.socket.on(id, (data) =>
            {
                observer.next(data);
            });

            // dispose the stream when the socket disconnects
            this.socket.on("disconnect", () =>
            {
                observer.complete();
            });
            // Return way to unsubscribe
            return () => {
                this.socket.close();
            };
        });

        return observable;
    }

    protected createAuthHeader(headers: Headers) {
        headers.append('Authorization', 'Bearer '+ this.window.sessionStorage.token);
    }
    changeSite(sites) {
        // for now the sites are arrays of arrays
        // but because we can only do live conns on one site at a time
        // we will just take the first record for now
        let site = sites[0];
        this.currentSite = site;
        // set the 'current' site to the one selected (if its not the one already current)
        // then update connection so the redis subscription change
        if (this.global.user.settings_global.current.name !== site.site) {
            let headers = new Headers();
            this.createAuthHeader(headers);
            return this.http.post(this.global.api+'/api/users/change_site', { info: site }, { headers })
                .subscribe(
                    (result) => {
                        let body = JSON.parse(result._body);
                        delete this.window.sessionStorage.token;
                        this.window.sessionStorage.token = body.token;
                        this.global.user.settings_global.current = body.current;
                        this.socket.disconnect();
                        this.connectSocket();
                        this.newStream.next();
                    },
                    (error) => {
                        alert('Unable to switch site.');
                    }

        }
    }
}




/** WEBPACK FOOTER **
 ** ./src/landing/directives/dashboard/dashboard.component.ts
 **/